import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const MetaAds = () => {
  const service = getDigitalMarketingService('meta-ads');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default MetaAds;
